import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, CardText } from 'react-md';
import { withSnackbar } from 'notistack';

import { I18nMarkdown } from '../../Components/Markdown';
import CONFIG from '../../Config';
import Footer from '../Login/Footer';
import Header from '../Login/Header';

import './Signature.scss';

class Signature extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // workaround: autoComplete="off" does not work in Chrome
  // https://github.com/mlaursen/react-md/issues/709
  componentDidMount() {
    // load .env
    this.setState({
      app: {
        title: '',
        subTitleSignature: CONFIG.subTitleSignature || 'Votre signature',
        logoRef: CONFIG.logoRef,
        logoLink: CONFIG.logoLink,
      },
    });
  }

  renderForm = () => {
    const { strings, theme } = this.props;
    const { app = {} } = this.state;

    const pathname = window.location.pathname.split('/');
    const status = pathname[pathname.length - 1]?.toLowerCase();

    return (
      <div className="coog-form-login">
        <Header theme={theme} app={app} strings={strings} mode="signature" />
        <Card className="md-block-centered card-block">
          <CardText>
            <div className="text">
              {status === 'ok' ? (
                <I18nMarkdown strings={strings} string="textSignatureOK" />
              ) : (
                <I18nMarkdown strings={strings} string="textSignatureKO" />
              )}
            </div>
          </CardText>
        </Card>
        <Footer theme={theme} app={app} strings={strings} />
      </div>
    );
  };

  render() {
    return this.renderForm();
  }
}

Signature.propTypes = {
  strings: PropTypes.shape({
    pageTitle: PropTypes.string,
    canonical: PropTypes.string,
    textForget: PropTypes.string,
    textMailSent: PropTypes.string,
  }),
  theme: PropTypes.object, // eslint-disable-line
};

Signature.defaultProps = {
  strings: {
    pageTitle: 'Coog Portal - Signature de documents',
    textSignatureOK: 'Merci pour la signature de votre document.',
    textSignatureKO: "La signature de votre document n'a pas pu aboutir.",
  },
  theme: {},
};

const mapStateToProps = state => {
  const theme = state.get('theme').toJS();

  return { theme };
};

export default withSnackbar(connect(mapStateToProps)(Signature));
